<script setup>
import TypesCloud from "./subjects/TypesCloud.vue";
import RentalItemModal from "./subjects/RentalItemModal.vue";
import {computed, ref, watch} from "vue";
import {useRentalItemTypes} from "../../helpers/useRentalItemTypes.js";
import RentalCard from "./subjects/RentalCard.vue";

const props = defineProps({
    formType: { type: String, default: 'rental' },
})

const valid = defineModel('valid');
const model = defineModel();

const currentItem = ref(false);
const selectedType = ref(false);

const effectiveFormType = computed(() => model.value?.selectedType || props.formType);

const newRentalItem = (type) => {
    const newId = Date.now().toString() + Math.random().toString(36).substring(2);
    const defaultType = useRentalItemTypes().rentalItemTypes.find(l_type => l_type.type === type);
    currentItem.value = {
        id: newId,
        name: '',
        description: '',
        icon: defaultType?.icon,
        type: '',
        calendar_id: null,
        unit: model.value.reservationType === 'multi-day' ? 'day' : 'hour',
        min_unit_quantity: 1,
        payment_style: 'before',
        unit_price: 0.00,
        max_pop: 2,
        vat_percentage: 0,
        currency: 'CZK',
        attributes: defaultType?.defaultAttributes ?? [],
        discounts: [],
        additional_costs: [],
        occupancy_rules: [],
        pop_rules: [],
        booking_rules: [],
        timeSlots: [],
        gallery: [],
    };
}

watch(() => selectedType.value, () => {
    if (!selectedType.value) return
    newRentalItem(selectedType.value);
})

watch(() => currentItem.value, (now) => {
    if (!now) selectedType.value = false
})

watch(() => model.value, (now) => valid.value = now.rentalItems.length > 0, { immediate: true, deep: true });
</script>

<template>
    <div class="flex flex-col">
        <TransitionGroup v-if="model.rentalItems.length" name="fade-slide" tag="div" class="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
            <rental-card
                v-for="(card, i) in model.rentalItems"
                :key="card.index || card.name"
                :item="card"
                @remove="() => model.rentalItems.splice(i, 1)"
                @edit="() => {
                  const copy = JSON.parse(JSON.stringify(card));
                  copy.index = i + 1;
                  currentItem = copy;
                }"
            ></rental-card>
        </TransitionGroup>
        <types-cloud v-model="selectedType" :form-type="effectiveFormType"></types-cloud>
        <rental-item-modal v-model="currentItem" v-model:form="model" @save="() => {
            if (currentItem.index)
            {
                model.rentalItems[currentItem.index - 1] = currentItem;
            } else {
                model.rentalItems.push(currentItem);
            }
            currentItem = false
        }"></rental-item-modal>
    </div>
</template>

<style scoped lang="scss">
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(15px);
}
.fade-slide-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>
